
export default function Header() {
    return(
        <header className="header">
            <img className="header-image" src="../images/Troll face.svg" alt="laughing face"/>
            <h2 className="header-text">Meme Generator</h2>
            <h3 className="header-subtext">share it for fun</h3>
        </header>
    )
}